module.exports = __webpack_public_path__ + "img/personImg.cbca55fb.svg";